<import-file [title]="'Import Dealer'" [isGeneric]="false" [documentType]="documentType.DealersGroup" [attachmentId]="attachmentId"></import-file>